'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InterpretedError = InterpretedError;
exports.NetworkError = NetworkError;
exports.HttpError = HttpError;
function InterpretedError() {
  var tmp = Error.apply(this, arguments);
  tmp.name = this.name = 'InterpretedError';
  this.message = tmp.message;
  Object.defineProperty(this, 'stack', {
    get: function get() {
      return tmp.stack;
    }
  });
}
InterpretedError.prototype = Object.create(Error.prototype);
InterpretedError.prototype.constructor = InterpretedError;

function NetworkError() {
  InterpretedError.apply(this, arguments);
}
NetworkError.prototype = Object.create(InterpretedError.prototype);
NetworkError.prototype.constructor = NetworkError;

function HttpError(message, status) {
  InterpretedError.call(this, message);
  this.status = status;
}
HttpError.prototype = Object.create(InterpretedError.prototype);
HttpError.prototype.constructor = HttpError;

/*

let e = new HttpError('hello');

console.log('e instanceof HttpError: ', e instanceof HttpError);
console.log('e instanceof Error: ', e instanceof Error);
console.log('e instanceof InterpretedError: ', e instanceof InterpretedError);
console.log('e', e);
debugger;*/


//////////////////
// WEBPACK FOOTER
// ../component-common/dist/error/Errors.js
// module id = 309
// module chunks = 0